import { render } from "./TaskCommentsLoader.vue?vue&type=template&id=eafe9d40"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__